import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit')({
  beforeLoad: () => getTitleContextSlice('Audit'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
